import React, { Component } from "react";
import { Descriptions } from "antd";

export default class PharmacyBasicInfoView extends Component {
  render() {
    const { details } = this.props;

    return (
      <Descriptions layout="vertical" bordered>
        <Descriptions.Item label="Name">
          {(details && details.name) || "--"}
        </Descriptions.Item>
        <Descriptions.Item label="Email">
          {(details && details.email) || "--"}
        </Descriptions.Item>
        <Descriptions.Item label={"Phone"}>
          {(details && details.phone_number) || "--"}
        </Descriptions.Item>
        <Descriptions.Item label="Town/City">
          {(details && details.location && details.location.city) || "--"}
        </Descriptions.Item>
        <Descriptions.Item label="State">
          {(details && details.location && details.location.state) || "--"}
        </Descriptions.Item>
      </Descriptions>
    );
  }
}
